export default __webpack_public_path__ + "static/media/MDS-5700.23f45693.png";